// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Ae3a","footer":"ModalCreateQualiphyProcedure_footer__2mbfB","additionData":"ModalCreateQualiphyProcedure_additionData__30Hlj"};